// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"82c428f6","455":"a99354b9","488":"f74df6f1","977":"ff5fd91e"}[chunkId] + ".chunk.js";
};